export const truncateText = (text, limit) => {
    text = text || '';
    let output = text.substr(0, limit).trim();
    if (text.length > limit) {
        output += '...';
    }

    return output;
};
